/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EmailLink from '../../../../client/js/components/links/EmailLink'
import PhoneLink from '../../../../client/js/components/links/PhoneLink'
import { getCustomerName } from '../../lib/customer.mjs'
import { Group, HoverCard, HoverCardProps, Loader, Stack } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { fetchCustomer } from '../../lib/rest/customerAPIClient'
import { useDisclosure } from '@mantine/hooks'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { getCustomerLink } from '../../lib/links/customerLinks'

export type CustomerInfoHoverCardProps = HoverCardProps & {
  customerId: number,
}

function CustomerInfoHoverCard (props: CustomerInfoHoverCardProps) {
  const {
    children,
    customerId,
    ...others
  } = props

  const [opened, { toggle }] = useDisclosure()

  const customerQuery = useQuery({
    enabled: customerId != null && opened,
    queryKey: ['customer', customerId],
    queryFn: () => fetchCustomer(customerId),
    refetchOnWindowFocus: false
  })
  const customer = customerQuery.data

  return (
    <HoverCard
      openDelay={500}
      closeDelay={200}
      onOpen={toggle}
      onClose={toggle}
      position="top"
      {...others}
    >
      <HoverCard.Target>
        {children}
      </HoverCard.Target>

      <HoverCard.Dropdown maw={300}>
        {customerQuery.isLoading
          ? <Loader size="sm" />
          : null}

        {customer != null
          ? <Stack gap="xs">
            <AnchorLink fw="bold" to={getCustomerLink(customerId)}>
              {getCustomerName(customer)}
            </AnchorLink>

            <Stack gap={0} fz="sm">
              {customer.mobile != null
                ? <Group wrap="nowrap">
                  <FontAwesomeIcon
                    fixedWidth
                    icon={faMobileAlt}
                  />
                  <PhoneLink phone={customer.mobile} />
                </Group>
                : null}

              {customer.phone != null
                ? <Group wrap="nowrap">
                  <FontAwesomeIcon
                    fixedWidth
                    icon={faPhoneAlt}
                  />
                  <PhoneLink phone={customer.phone} />
                </Group>
                : null}

              {customer.email != null
                ? <Group wrap="nowrap">
                  <FontAwesomeIcon
                    fixedWidth
                    icon={faEnvelope}
                  />
                  <EmailLink email={customer.email} />
                </Group>
                : null}

              {customer.email2 != null
                ? <Group wrap="nowrap">
                  <FontAwesomeIcon
                    fixedWidth
                    icon={faEnvelope}
                  />
                  <EmailLink email={customer.email2} />
                </Group>
                : null}
            </Stack>
          </Stack>
          : null}
      </HoverCard.Dropdown>
    </HoverCard>
  )
}

export default CustomerInfoHoverCard
